import Vue from 'vue';
import App from './App.vue';
import components from '@/components';
import plugins from '@/plugins';
import filters from '@/filters';
import template from '@/template';
import pages from '@/pages';
import modules from '@/modules';
import router from '@/plugins/router';
import { VueCore } from '@/core';

const options = {
  router,
};

Vue.use(plugins);
Vue.use(VueCore, options);
Vue.use(filters);
Vue.use(components);
Vue.use(template);
Vue.use(modules, options);
Vue.use(pages, options);

new Vue({
  router,
  render: h => h(App),
  mounted() {
    this.$core.el = this;
    window.core = this.$core;
  },
}).$mount('#app-mag');
